import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface MenuItemsQualificationProps {
  disabled?: boolean;
  value: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  items: Array<ItemVM>;
}

const MenuItemsQualification = ({
  disabled,
  onChange,
  value,
  items,
}: MenuItemsQualificationProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="qualification-label">Qualifica</InputLabel>
      <PmiSelect
        labelId="qualification-label"
        id="qualification"
        name="qualification"
        value={value}
        label="Qualifica"
        onChange={onChange}
        disabled={disabled}
      >
        {items.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MenuItemsQualification.displayName = 'Menu items Qualification component';

export default memo(MenuItemsQualification) as typeof MenuItemsQualification;
